import { Box, Button, Dialog, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useWhapi, useWhapiGroups, useWhapiTags } from 'context';
import CreateNew from './CreateNew';
import ListGroup from './ListGroup';
import ListTags from './ListTags';
import { PlusCircle } from 'lucide-react';
import { TagMemberType } from 'type/type';

const SideGroup = () => {
  const theme = useTheme();
  const tagData = useWhapiGroups() ?? [];
  const tagNameArr = useWhapiTags() ?? [];
  const { selectedTags, setSelectedTags, selectedGroups, setSelectedGroups, setExcludedGroups, syncGroupsFunction } = useWhapi();
  const [openDialog, setOpenDialog] = useState(false);
  const handleSelectTag = (tag: string) => {
    if (!tag) return;
    if (selectedTags.includes(tag)) {
      setSelectedTags(prev => {
        const clonedArr = [...prev.filter(item => item !== tag)];
        return clonedArr;
      });
      setSelectedGroups(prev => {
        const clonedArr = [...prev.filter(item => item.PartitionKey !== tag)];
        return clonedArr;
      });
    } else {
      setSelectedTags(prev => {
        const clonedArr = [...prev, tag];
        return clonedArr;
      });
      setSelectedGroups(currentlySelected => {
        const tagMembers = tagData.find(item => item.name === tag);
        if (!tagMembers) return currentlySelected;
        let clonedArr: TagMemberType[] = [];
        if (tagMembers.members.some(member => currentlySelected.includes(member))) {
          const addingMembers = tagMembers.members.filter(member => !currentlySelected.includes(member));
          return (clonedArr = [...currentlySelected, ...addingMembers]);
        }
        if (!tagMembers.members.some(member => currentlySelected.includes(member))) {
          return (clonedArr = [...currentlySelected, ...tagMembers.members]);
        }
        return clonedArr;
      });
    }
  };

  useEffect(() => {
    const selectedTagData = tagData.filter(item => selectedTags.includes(item.name));
    const modifiedTagData = selectedTagData.map(item => {
      const filteredMember = item.members.filter(member => !selectedGroups.includes(member));
      return {
        ...item,
        members: filteredMember,
      };
    });
    setExcludedGroups(modifiedTagData);
  }, [selectedTags, selectedGroups]);

  return (
    <Box
      sx={{
        minWidth: 100,
        maxWidth: 450,
        width: '100%',
        height: ' 100%',
        display: 'flex',
        boxShadow: 'inset 2px 0px 5px var(--black005)',
      }}
    >
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <CreateNew type='group' setOpenDialog={setOpenDialog} />
      </Dialog>

      <Box sx={{ width: '45%', display: 'flex', flexDirection: 'column', boxShadow: `inset 2px 0 5px ${theme.palette.mode === 'light' ? 'var(--black01)' : 'var(--white01)'}` }}>
        <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center', padding: '10px', bgcolor: theme.palette.mode === 'light' ? 'var(--black01)' : 'var(--white01)' }}>
          <p style={{ fontSize: 14, fontWeight: 600 }}>Tags</p>
          <p style={{ fontSize: 14 }}>({tagNameArr?.length ?? 0})</p>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
          <p>{selectedTags.length} Selected Item(s)</p>
          <Button
            size={'small'}
            disabled={selectedTags.length === 0}
            variant='text'
            sx={{ fontSize: '8px !important', padding: '5px 0 !important', width: '25px !important' }}
            onClick={() => {
              setSelectedGroups([]);
              setSelectedTags([]);
            }}
          >
            Uncheck
          </Button>
        </Box>
        <ListTags handleSelectTag={handleSelectTag} />
        <Button
          variant='contained'
          color={'secondary'}
          sx={{ height: '44px', display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', bgcolor: theme.palette.mode === 'light' ? 'var(--black03)' : 'var(--white02)', borderRadius: 0, marginTop: '20px' }}
        >
          <PlusCircle />
          Create New
        </Button>
      </Box>
      <Box sx={{ width: '55%', display: 'flex', flexDirection: 'column', boxShadow: `inset 2px 0 5px ${theme.palette.mode === 'light' ? 'var(--black01)' : 'var(--white01)'}` }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', bgcolor: theme.palette.mode === 'light' ? 'var(--black01)' : 'var(--white01)' }}>
          <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            <p style={{ fontSize: 14, fontWeight: 600 }}>Groups</p>
            <p style={{ fontSize: 14 }}>({tagData?.length ?? 0})</p>
          </Box>
          <Button variant='text' color='info' onClick={() => syncGroupsFunction()}>
            <p style={{ fontSize: '10px' }}>Sync Groups</p>
          </Button>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
          <p>{selectedGroups.length} Selected Item(s)</p>
          <Button
            size={'small'}
            disabled={selectedGroups.length === 0}
            variant='text'
            sx={{ fontSize: '8px !important', padding: '5px 0 !important', width: '25px !important' }}
            onClick={() => {
              setSelectedGroups([]);
              setSelectedTags([]);
            }}
          >
            Uncheck
          </Button>
        </Box>
        <ListGroup />
      </Box>
    </Box>
  );
};

export default SideGroup;
